import React, { createContext, useState, useContext } from 'react';

const INIT_VIEW = 'CampaignPerformanceAnalytics';

interface InsightProviderProps {
  children: React.ReactNode;
}

interface InsightContextType {
  activeView: string;
  setActiveView: (activeView: string) => void;
}
interface CookieProviderProps {
  children: React.ReactNode;
}

interface CookieContextType {
  cookie: string;
  setCookie: (cookie: string) => void;
}

const InsightContext = createContext({
  activeView: '',
  setActiveView: () => {
    return;
  },
} as InsightContextType);

export const InsightProvider = ({ children }: InsightProviderProps): React.ReactElement => {
  const [activeView, setActiveView] = useState<string>(INIT_VIEW);

  return (
    <InsightContext.Provider value={{ activeView, setActiveView }}>
      {children}
    </InsightContext.Provider>
  );
};
export const useInsightContext = () => useContext(InsightContext);

const CookieContext = createContext({
  cookie: '',
  setCookie: () => {
    return;
  },
} as CookieContextType);

export const CookieProvider = ({ children }: CookieProviderProps): React.ReactElement => {
  const [cookie, setCookie] = useState<string>('');

  return <CookieContext.Provider value={{ cookie, setCookie }}>{children}</CookieContext.Provider>;
};
export const useCookieContext = () => useContext(CookieContext);
